import React from "react";
import { Link } from "react-router-dom";
import { Zap, Truck, ShieldCheck, Clock } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-gray-100 bg-[#FAFAF7] mt-16" data-testid="vm-footer">
      <div className="max-w-7xl mx-auto px-4 lg:px-6 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <div className="h-9 w-9 rounded-xl bg-grass-500 flex items-center justify-center">
                <Zap className="h-5 w-5 text-white" />
              </div>
              <span className="font-display text-lg font-bold text-[#0F1115]">
                Quiktronic
              </span>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed max-w-xs">
              Quick commerce for electronics. Shop, repair, and resell — all in minutes.
            </p>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-wider text-gray-500 mb-3">Shop</p>
            <ul className="space-y-2 text-sm text-gray-700">
              <li><Link to="/shop?category=phones" className="hover:text-grass-700">Smartphones</Link></li>
              <li><Link to="/shop?category=laptops" className="hover:text-grass-700">Laptops</Link></li>
              <li><Link to="/shop?category=audio" className="hover:text-grass-700">Audio</Link></li>
              <li><Link to="/shop?category=gaming" className="hover:text-grass-700">Gaming</Link></li>
            </ul>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-wider text-gray-500 mb-3">Services</p>
            <ul className="space-y-2 text-sm text-gray-700">
              <li><Link to="/services" className="hover:text-grass-700">Repair booking</Link></li>
              <li><Link to="/services" className="hover:text-grass-700">Installation</Link></li>
              <li><Link to="/buyback" className="hover:text-grass-700">Sell old device</Link></li>
            </ul>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-wider text-gray-500 mb-3">Why Quiktronic</p>
            <ul className="space-y-2.5 text-sm text-gray-700">
              <li className="flex items-center gap-2"><Clock className="h-4 w-4 text-grass-600" /> 30-min delivery</li>
              <li className="flex items-center gap-2"><ShieldCheck className="h-4 w-4 text-grass-600" /> 100% authentic</li>
              <li className="flex items-center gap-2"><Truck className="h-4 w-4 text-grass-600" /> Free pickup</li>
            </ul>
          </div>
        </div>

        <div className="vm-divider my-8" />
        <div className="flex flex-col md:flex-row justify-between gap-2 text-xs text-gray-500">
          <p>© {new Date().getFullYear()} Quiktronic — Quick commerce for electronics</p>
          <p className="flex gap-4">
            <Link to="/privacy" className="hover:text-grass-700" data-testid="footer-privacy-link">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-grass-700" data-testid="footer-terms-link">Terms of Service</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
